import { useState, Fragment, useEffect, JSX, useContext } from 'react';
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
// import Button from '@mui/material/Button';
import status_img from '../UserHomepage/status_with_payment.jpg';
// import Footer from '../Footer/Footer';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Layout, Menu, theme, Spin, Button, Grid, Divider, Typography, Card, Table, Modal, Steps, Flex } from 'antd';
import { CheckOutlined, RightCircleFilled } from "@ant-design/icons";
// import { BackendAPI } from "../axios";
import axios from 'axios';
import type { MenuProps, StepsProps } from 'antd';
import UserResetPassword from '../AuthComponents/ChangePassword/UserPasswordChange'
import { setUser } from '../../store/userSlice';
import { useDispatch, UseDispatch } from 'react-redux';
import { useSelector } from "react-redux";
import { RootState } from '../../store/store';



import {
    AppstoreOutlined,
    CheckCircleFilled,
    CheckCircleOutlined,
    ContainerOutlined,
    DesktopOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
    FileOutlined,
    MailOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined,
    TeamOutlined,
    UserOutlined,
} from '@ant-design/icons';
import { BackendAPI } from '../../axios';
import { Field, Form, Formik } from 'formik';
import UserHeader from '../AuthComponents/UserHeader';
import { Footer, Header } from 'antd/es/layout/layout';
import UserNavbar from './UserNavbar';
import './User.scss';
import collapse_icon from '../../assets/images/collapse_icon.svg';
import cdac_logo from '../../assets/images/svg_img/logo_cdac.svg';
import ChangePasswordFirstTime from './ChangePassword/ChangePasswordFirstTime';
import { UserContext } from "./UserContext";
import UserDashboard from '../AuthComponents/TransactionDashboard';
import Txnsummary from './TxnCostSummary/Txnsummary';
// import Title from 'antd/es/skeleton/Title';
const { Content, Sider } = Layout;
const { Title } = Typography;
const THEME_COLOR = "#1515b4";

const MySwal = withReactContent(Swal);

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
    } as MenuItem;
}

const items: MenuItem[] = [
    getItem('Option 1', '1', <PieChartOutlined />),
    getItem('Option 2', '2', <DesktopOutlined />),
    getItem('User', 'sub1', <UserOutlined />, [
        getItem('Tom', '3'),
        getItem('Bill', '4'),
        getItem('Alex', '5'),
    ]),
    getItem('Team', 'sub2', <TeamOutlined />, [getItem('Team 1', '6'), getItem('Team 2', '8')]),
    getItem('Files', '9', <FileOutlined />),
];

const statuses = [
    "Application / Enquiry Form Submitted",
    "Agreement Signed",
    "Payment Received",
    "Onboarded",
    "Integration Initiated",
    "Integration Completed",
];


function UserHome(): JSX.Element {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const navigate = useNavigate();

    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 830);

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [changePsswordOpenModal, setChangePsswordOpenModal] = useState(false);
    const [isOnClickSlider, setOnclickSlider] = useState(false);
    const [isSetPasswordFlag, setIsSetPasswordFlag] = useState(false);
    const [isUserDeactivated, setIsUserDeactivated] = useState(false);

    const { setUsername } = useContext(UserContext);

    const [currentStatus, setCurrentStatus] = useState<string>();
    const [status, setStatus] = useState<string>();

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [captchaText, setCaptchaText] = useState("");
    const [captchaImage, setCaptchaImage] = useState("");

    const [isOpenTxnDashboard, setIsOpenTxnDashboard] = useState<boolean | null>(true);

    // ============================
    // Redux
    // ============================
    const userfromstore = useSelector(
        (state: RootState) => state.user.user
    );

    useEffect(() => {
        if (!userfromstore) return;

        setUsername(userfromstore.username);
        setChangePsswordOpenModal(!userfromstore.set_password_flag);
        setIsSetPasswordFlag(!userfromstore.set_password_flag);

    }, [userfromstore, setUsername]);

    const currentStep = statuses.findIndex(
        (status) => status === currentStatus
    );

    const handleCollapse = () => {
        setCollapsed(!collapsed);
        setOnclickSlider(!isOnClickSlider);
    };

    let refreshToken: null = null;

    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get(
                "/user/refresh-token",
                {
                    withCredentials: true,
                }
            );

            refreshToken = response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status === 401) {
                    window.location.reload();
                }
            }
        }
    };
    
   const getStatus = async () => {
    const url = `/user/status`;

    const header = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${refreshToken}`,
        },
    };

    try {
        const response = await BackendAPI.get(url, header);

        setStatus(response.data);
        setCurrentStatus(response.data);
        setIsUserDeactivated(response.data === "Deactivated");

        if (response.data === "Integration Completed") {
            setIsOpenTxnDashboard(true);
        }

        console.log("User status response:", response.data);

    } catch (error) {
        console.error("Error fetching user status:", error);

        if (axios.isAxiosError(error)) {
            if (error.request.status === 401) {
                backToHome();
            }
        }
    }
};


/**
 * Sync UI state from Redux store
 */
useEffect(() => {

    if (!userfromstore) return;

    console.log("User From Redux :", userfromstore);

    setUsername(userfromstore.username);

    setChangePsswordOpenModal(!userfromstore.set_password_flag);

    setIsSetPasswordFlag(!userfromstore.set_password_flag);

}, [userfromstore, setUsername]);


const fetchCaptchaImage = async () => {

    const header = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const url = `/user/generate`;

    try {

        const response = await BackendAPI.get(url, header);

        setCaptchaImage(response.data.base64Image);
        setCaptchaText(response.data.captchaText);

    } catch (error) {

        console.error("Error fetching captcha:", error);

        if (axios.isAxiosError(error)) {
            if (error.request.status === 401) {
                backToHome();
            }
        }
    }
};


const backToHome = async () => {

    try {

        const response = await BackendAPI.post(
            "/user/logout",
            {},
            { withCredentials: true }
        );

        if (response.status === 200) {
            localStorage.removeItem("authToken");
            navigate("/");
        }

    } catch (error) {
        console.error(error);
    }
};
useEffect(() => {
    const executeFunctions = async () => {
        await getRefreshToken();
        await getStatus();
        await fetchCaptchaImage();

        // No need to call getUserInfo() anymore.
        // User information is loaded in PrivateLayout and stored in Redux.
    };

    executeFunctions();
}, []);

const data = [
    {
        label: "Organization Name",
        value: userfromstore?.organizationName ?? "-",
    },
    {
        label: "Service Type",
        value: userfromstore?.serviceType ?? "-",
    },

    ...(userfromstore?.serviceType !== "asa"
        ? [
              {
                  label: "Sub-AUA Code",
                  value: userfromstore?.sacode ?? "Not Generated",
              },
          ]
        : []),

    ...(userfromstore?.serviceType !== "aua"
        ? [
              {
                  label: "AUA Code Pre-Production",
                  value: userfromstore?.aua_kua_code ?? "Not Generated",
              },
          ]
        : []),

    ...(userfromstore?.serviceType !== "aua"
        ? [
              {
                  label: "AUA Code Production",
                  value: userfromstore?.aua_kua_code_prod ?? "Not Generated",
              },
          ]
        : []),

    {
        label: "Current Status",
        value: status ?? "-",
    },
];

const dataSource = data.map((item, index) => ({
    key: index,
    label: item.label,
    value: item.value ? item.value.toString().toUpperCase() : "-",
}));

const columns = [
    {
        dataIndex: "label",
        key: "label",
        width: "50%",
        render: (text: string) => <strong>{text}</strong>,
    },
    {
        dataIndex: "value",
        key: "value",
        width: "50%",
    },
];

const steps: NonNullable<StepsProps["items"]> = statuses.map((title) => ({
    title,
}));

const openIntegrationStatus = () => {
    setIsOpenTxnDashboard(true);
};

useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 830);
    };

    window.addEventListener("resize", handleResize);

    return () => {
        window.removeEventListener("resize", handleResize);
    };
}, []);

return (
        <>
            {/* {status === 'Integration Completed' ? (
                <Txnsummary />
            ) : ( */}

            <div id="app-content">
                {/* <div>
                        <UserHeader setIsOnClickSlider={setOnclickSlider} />
                    </div> */}
                <Layout style={{ minHeight: '89vh', }}>

                    <Sider
                        collapsed={isMobile ? true : isOnClickSlider}
                        // trigger={null} // disable default trigger
                        // collapsible
                        collapsedWidth={50}
                        // onCollapse={handleCollapse}
                        style={{
                            // height: '90vh',
                            background: 'white',
                            position: 'relative',
                            overflow: 'auto',
                            top: '0px',
                            paddingTop: '20px',
                        }}
                    >
                        {/* Custom collapse icon at top */}

                        <div style={{ top: '0', position: 'sticky', height: '100%', }}>
                            {/* Add menu or other content here */}
                            {/* <div
                            style={{
                                position: 'absolute',
                                top: 0, textAlignLast: 'right',
                                cursor: 'pointer', width: '100%', padding: '6px 16px',
                            }}
                            onClick={handleCollapse}
                        >
                            {collapsed ? <MenuUnfoldOutlined style={{ fontSize: '30px', }} /> : <MenuFoldOutlined style={{ fontSize: '30px', }} />}
                        </div> */}
                            <UserNavbar />
                            {/* <div style={{ textAlignLast: 'center', transition: 'all 0.9s', display: isOnClickSlider ? 'none' : 'block', position: 'absolute', justifySelf: 'center', bottom: '2%', }}>
                            <img src={cdac_logo} alt="Status" style={{ width: '40%', height: 'auto' }} />
                            <h5 style={{ textAlign: 'center', margin: '0' }}>Center for Development of Advanced Computing (C-DAC)</h5>
                        </div> */}
                        </div>
                    </Sider>
                    <Layout style={{ alignSelf: 'center',  }}>
                        {isOpenTxnDashboard == null  ? (
                            <Spin size="large" />
                        ) : !isOpenTxnDashboard ? (
                        <Content style={{ padding: 16 }} className='user-homepage'>
                            <Card
                                style={{
                                    borderRadius: 14,
                                    background: 'white',
                                }}
                                bodyStyle={{ padding: 32 }}
                            >
                                {/* Header */}
                                {/* Header */}
<div
    style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
        marginBottom: 32,
        flexWrap: "wrap",
    }}
>
    <Title
        level={3}
        style={{
            color: THEME_COLOR,
            borderBottom: `3px solid ${THEME_COLOR}`,
            display: "inline-block",
            paddingBottom: 6,
            margin: 0,
        }}
    >
        Onboarding / Integration Status
    </Title>

    <Button
        type="primary"
        onClick={openIntegrationStatus}
        style={{
            background: "#4a4ac4",
            color: "white",
            border: "none",
            borderRadius: 6,
            padding: "8px 20px",
            fontWeight: 600,
            flexShrink: 0,
        }}
    >
        View Dashboard
    </Button>
</div>
                                <Flex vertical style={{ width: "100%", paddingBottom: '20px', }}>
                                    <div
                                    // style={{ overflowX: "auto" }}
                                    >
                                        <Steps
                                            current={currentStep}
                                            items={steps}
                                            // progressDot
                                            titlePlacement="vertical"
                                            // style={{ minWidth: 1200 }}
                                            className="responsive-steps"
                                        />
                                    </div>
                                </Flex>

                                {/* Details Table */}
                                {/* <Card
          bordered
          style={{
            borderRadius: 12,
            boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
          }}
        > */}   
                                <Table
                                    showHeader={false}
                                    dataSource={dataSource}
                                    columns={columns}
                                    pagination={false}
                                    bordered
                                    className="dashboard-ant-table-modern"
                                />

                                {/* </Card> */}
                            </Card>
                        </Content>
                    ) : (
                        <Content style={{ padding: '0px 0px', overflowY: 'auto', maxHeight: 'calc(100vh - 80px)', paddingBottom: 32 }}>
                        <UserDashboard setIsOpenTxnDashboard={setIsOpenTxnDashboard}/>
                        </Content>
                    )}
                        { isOpenTxnDashboard != null && (
                            <Footer style={{ textAlign: 'center' }}>
                                ©2025 Copyright: C-DAC Mumbai. All Rights Reserved
                            </Footer>
                        )}
                    </Layout>
                </Layout>
                <style>
                    {`
      .ant-modal-mask {
        backdrop-filter: blur(10px);
        background-color: rgba(13, 5, 54, 0.25) !important;
      }
    `}
                </style>
                <Modal
                    open={isSetPasswordFlag}
                    //    onCancel={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    footer={null}
                    centered
                >
                    <ChangePasswordFirstTime />
                </Modal>
                <Modal
                    open={isUserDeactivated}
                    //    onCancel={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    footer={null}
                    centered
                >
                    {/* <Card> */}
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <MailOutlined style={{ fontSize: '50px', color: '#ff4d4f' }} />
                        <h2>Your account has been deactivated.</h2>
                    </div>
                    {/* </Card> */}
                </Modal>
            </div>
            {/* )} */}
        </>
    )
}

export default UserHome;
